// extracted by mini-css-extract-plugin
export default {"ChatWindow":"styles_ChatWindow__1EqXo"};